import { BaseCommand } from './baseCommand';
import Element, { ElementType } from '../element';
import { handlesManager } from '../handlesManager';
import { positionManager } from '../positionManager';
import { hingesManager } from '../hingesManager';
import { AddHingesToFrontCommand } from './addHingesToFrontCommand';
import { HelpPoint } from '../helpPoint';

export default class ChangeHandlePositionCommand extends BaseCommand {

    private removedHinges: Element[] = [];

    constructor(
        private front: Element,
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public execute(): void {
        if (!handlesManager.canChangeHandlePosition(this.front)) {
            return;
        }
        const helpPoint = this.changeHandlePosition();
        this.removeOldHinges();
        this.addNewHinges(helpPoint);
    }

    public revert() {
        super.revert();
        this.removedHinges.forEach((x) => {
            this.scenePreview.elements.push(x);
            x.isVisible = true;
            x.bind(this.front);
        });
        this.changeHandlePosition();
    }

    private changeHandlePosition(): HelpPoint {
        const helpPoint = handlesManager.getOppositeHelpPoint(this.front);
        const handle = this.front.bindings.find((x) =>
            x.type === ElementType.HANDLE)!;
        if (handle) {
            handle.freeze(false);
            positionManager.positionWithParent(handle, this.front.center, helpPoint);
            handle.freeze(true);
        }
        return helpPoint;
    }

    private removeOldHinges() {
        const hinges = this.front.bindings.filter((x) => x.type === ElementType.HINGE);
        this.removedHinges = hinges;
        hinges.forEach((x) => {
            x.unbind(this.front);
            x.isVisible = false;
            this.scenePreview.elements.splice(this.scenePreview.elements.indexOf(x), 1);
        });
    }

    private addNewHinges(helpPoint: HelpPoint) {
        const hingeModels = hingesManager.getHingesForHelpPoint(helpPoint);
        const command = new AddHingesToFrontCommand(
            this.front,
            this.scenePreview,
            hingeModels,
        );
        this.addCommand(command);
    }
}
